import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app-service.service';

@Component({
  selector: 'app-summary-image',
  templateUrl: './summary-image.component.html',
  styleUrls: ['./summary-image.component.scss'],
})
export class SummaryImageComponent {
  image: any = '';
  chapterId: any = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private appService: AppService) {
    this.chapterId = data.finishedChapterId;
    console.log('Chapter ID from dialog:', this.chapterId, data.finishedChapterId); // Debugging line
    this.loadImage();
  }

  loadImage() {
    console.log('Loading image for chapterId:', this.chapterId); 
    this.appService.getSummaryImage(this.chapterId).subscribe((response: any) => {
      this.image = response.image;
    });
  }
}